'use strict';

module.exports = function(fn, ctx) {
  if (fn.bind) {
    return fn.bind(ctx);
  }
  return function() {
    return fn.apply(ctx, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./lib/proxy.js
// module id = 16
// module chunks = 1 3